<template>
  <main class="login-main">
    <header>
      <img alt="Ibility logo" class="logo" src="../assets/images/iblity_black.svg" width="60" height="40" />
    </header>
    <div class="login-container">
      <div class="left">

        <h1 class="main-text">
          {{$t('start_evolving_with')}}<br/>
          {{$t('start_evolving_with_2')}}<br/>
          {{$t('new_generation_learning')}}<br/>
        </h1>

        <img class="main-image" alt="Illustration" src="../assets/images/loginIcon.png" />

        <div class="store-buttons">
          <a href="https://apps.apple.com/us/app/ibilityapp/id6504390517" target="_blank" rel="noopener noreferrer" class="store-button app-store">
            <img src="../assets/images/appStore.svg">
            <div class="store-text">
              <span class="store-subtitle">{{$t('download')}}</span>
              <span class="store-title">App Store</span>
            </div>
          </a>
          <a href="https://play.google.com/store/apps/details?id=com.ibility" target="_blank" rel="noopener noreferrer" class="store-button play-store">
            <img src="../assets/images/playStore.svg">
            <div class="store-text">
              <span class="store-subtitle">{{$t('download')}}</span>
              <span class="store-title">Google Play</span>
            </div>
          </a>
        </div>
      </div>
      <div class="right">
        <div v-if="isLoginScreen" class="login-form">
          <div class="welcome-back">
            <img alt="Ibility dots" class="login-image" src="../assets/images/login_dots.svg" />
            <h2 class="login-form-title">{{$t('welcome_back')}}</h2>
          </div>
          <span class="form-label">{{$t('e_mail')}}</span>
          <div class="input-holder">
            <input class="form-input" v-model="email" :placeholder="this.$t('enter_your_work_e-mail')" />
            <img v-if="isEmailVerified" class="icon" alt="Check" src="../assets/images/check.svg"/>
          </div>
          <span class="form-label">{{$t('password')}}</span>
          <div class="input-holder">
            <input type="password" v-model="password" class="form-input" :placeholder="this.$t('enter_your_password')" @keyup.enter="login"/>
            <img v-if="password.length > 3" class="icon" alt="Check" src="../assets/images/check.svg" />
          </div>
          <router-link to="/" style="width: 100%">
            <button class="circular-btn" @click="login">
              <span v-if="!loading">{{$t('log_in')}}</span>
              <VueSpinnerIos v-else size="20" height="100%" color="#fff" />
            </button>
          </router-link>

         <!-- <button class="circular-outline-btn mt-2" @click="openCreateAccount">
            <span>{{$t('create_account')}}</span>
          </button> -->

          <div class="policy-text">
            <span>{{$t('accept_one')}}</span>
            <span class="policy-text-two" @click="openTermsModal">{{$t('accept_two')}}</span>
            <span>{{$t('accept_three')}}</span>
            <span class="policy-text-two" @click="openPrivacyModal">{{$t('accept_four')}}</span>
            <span>{{$t('accept_five')}}</span>
          </div>

          <div class="forgot-password">
            {{$t('forgot_password')}} <router-link to="/reset-password">{{$t('reset_password')}}</router-link>
          </div>

          <div class="language-selector">
            <TranslationDropdown :show-warning="false" :selected-language="$i18n.locale" :on-select="updateLanguage"/>
          </div>
        </div>
        <div v-else class="register-form">
          <div  @click="backLogin" class="back-button">
            <img src="@/assets/images/arrowLeft.svg" />
          </div>
          <div class="register-header">
            <h2 class="register-title">{{$t('create_account')}}</h2>
          </div>
          <form @submit.prevent="register">
            <div class="register-grid">
              <div class="form-group">
                <span class="form-label">{{$t('company_name_person')}}</span>
                <input class="form-input" v-model="registerForm.company_name" :placeholder="this.$t('enter_company_name_placeholder')" />
              </div>
              <div class="form-group">
                <span class="form-label">{{$t('login_name')}}</span>
                <input class="form-input" v-model="registerForm.authorized_name" :placeholder="this.$t('login_name')" />
              </div>
              <div class="form-group">
                <span class="form-label">{{$t('login_surname')}}</span>
                <input class="form-input" v-model="registerForm.surname" :placeholder="this.$t('login_surname')" />
              </div>
              <div class="form-group">
                <span class="form-label">{{$t('address')}}</span>
                <input class="form-input" v-model="registerForm.company_address" :placeholder="this.$t('enter_address')" />
              </div>
              <div class="form-group">
                <span class="form-label">{{$t('authorized_phone')}}</span>
                <PhoneInput v-model="registerForm.authorized_phone" />
              </div>
              <div class="form-group">
                <span class="form-label">{{$t('email')}}</span>
                <input class="form-input" v-model="registerForm.authorized_email" :placeholder="this.$t('email')" />
              </div>


              <div class="form-group">
                <span class="form-label">{{$t('country_person')}}</span>
                <SelectBox
                    :full-width="true"
                    :loading="countriesLoading"
                    :options="countries"
                    :selected-value="registerForm.company_country_id"
                    :on-select="handleAccountCountry"
                    :placeholder="this.$t('select_country')"
                />
              </div>

              <div class="form-group">
                <span class="form-label">{{$t('city_person')}}</span>
                <SelectBox
                    v-if="registerForm.company_country_id === 218"
                    :full-width="true"
                    :loading="citiesLoading"
                    :options="cities"
                    :selected-value="registerForm.company_city_id"
                    :on-select="handleAccountCity"
                />
                <input
                    v-else
                    class="form-input"
                    type="text"
                    :placeholder="this.$t('city_person')"
                    v-model="registerForm.cityName"
                />
              </div>

              <div class="form-group">
                <span class="form-label">{{$t('region_title')}}</span>

                <SelectBox
                    :full-width="true"
                    :options="databaseList"
                    :selected-value="registerForm.region"
                    :on-select="selectRegion"
                    :placeholder="this.$t('select_region')"
                />
              </div>

              <div class="form-group">
                <span class="form-label">{{$t('sector')}}</span>
                <SelectBox
                    :full-width="true"
                    :loading="sectorsLoading"
                    :options="sectors"
                    :selected-value="registerForm.sectorId"
                    :on-select="handleSectorSelect"
                    :placeholder="this.$t('select_sector')"
                />
              </div>
            </div>
            <button class="circular-btn" type="submit">
              <span v-if="!loading">{{$t('create_account')}}</span>
              <VueSpinnerIos v-else size="20" height="100%" color="#fff" />
            </button>
            <div class="policy-text">
              <span>{{$t('accept_one')}}</span>
              <span class="policy-text-two" @click="openTermsModal">{{$t('accept_two')}}</span>
              <span>{{$t('accept_three')}}</span>
              <span class="policy-text-two" @click="openPrivacyModal">{{$t('accept_four')}}</span>
              <span>{{$t('accept_five')}}</span>

            </div>
          </form>
        </div>
      </div>
    </div>

    <PrivacyTextModal
        :isVisible="showPrivacyModal"
        @close="closePrivacyModal"
    />

    <TermsOfUseModal
        :isVisible="showTermsModal"
        @close="closeTermsModal"
    />


  </main>
</template>


<script>
import authService from "@/service/authService";
import {
  VueSpinnerIos
} from 'vue3-spinners'
import {handleErrorResponse} from "@/utils/utils";
import PhoneInput from "@/components/PhoneInput.vue";
import SelectBox from "@/components/SelectBox.vue";
import commonService from "../service/commonService";
import PrivacyTextModal from "@/components/modals/PrivacyTextModal.vue";
import TermsOfUseModal from "@/components/modals/TermsOfUseModal.vue";
import TranslationDropdown from "@/components/TranslationDropdown.vue";

export default {
  name: 'Login',
  components: {
    TermsOfUseModal,
    SelectBox,
    PhoneInput,
    VueSpinnerIos,
    PrivacyTextModal,
    TranslationDropdown,
  },
  data() {
    return {
      email: '',
      password: '',
      isEmailVerified: false,
      loading: false,
      isLoginScreen: true,
      countries: [],
      countriesLoading: true,
      regionDropdown: false,
      selectedRegion: null,
      cities: [],
      citiesLoading: true,
      sectors: [],
      sectorsLoading: true,
      registerForm: {
        company_name: "",
        company_address: "",
        company_city_id: null,
        authorized_name: "",
        authorized_email: "",
        authorized_phone: "",
        surname: "",
        region: "",
        company_country_id: "",
        sectorId: "",
      },
      databaseList: [
        { value: 'TR', text: 'TR' },
        { value: 'EU', text: 'EU' }
      ],
      showPrivacyModal: false,
      showTermsModal: false,
    }
  },
  watch: {
    email(newValue) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      this.isEmailVerified = emailRegex.test(newValue);
    }
  },
  async mounted() {
    if (this.$route.query.isRegister === 'true') {
      this.isLoginScreen = true;
      // register gizlendi
      // this.isLoginScreen = false;
    }
    this.getCountries();
    this.getCities();
    this.getSectors();
    this.isLoading = false;
  },
  computed: {
    selectedRegionLabel() {
      if (this.selectedRegion === 'TR') return 'TR';
      if (this.selectedRegion === 'EU') return 'EU';
      return '';
    }
  },
  methods: {
    login() {
      if (this.isEmailVerified && this.password.length > 3 && !this.loading) {
        this.loading = true;

        authService.login(this.email,this.password).then(response => {
          const data = response.data.data;

          if (data.status === true) {
            localStorage.setItem('authToken', data.token);
            localStorage.setItem('user', JSON.stringify(data));
            this.$router.push('/');
          }

          this.loading = false;
        }).catch(error => {
          this.loading = false;
          handleErrorResponse(error, this.$snackbar);
        })
      }
      else{
        this.$snackbar.add({
          text: this.$t('InvalidEmail'),
          type:"error",
        })
      }
    },
    openCreateAccount() {
      this.isLoginScreen = false;
      if (this.sectors.length === 0) {
        this.getSectors();
      }
    },
    backLogin() {
      this.isLoginScreen = true;
    },
    getCountries() {
      this.countriesLoading = true;
      commonService.getCountries().then((res) => {
        const countryTemp = res.data.data.country;
        this.countries = countryTemp.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.countriesLoading = false;
      }).catch((err) => {
        this.countriesLoading = false;
      });
    },
    getCities() {
      this.citiesLoading = true;
      commonService.getCities().then((res) => {
        const cityTemp = res.data.data.cities;
        this.cities = cityTemp.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.citiesLoading = false;
      }).catch((err) => {
        this.citiesLoading = false;
      });
    },
    getSectors() {
      this.sectorsLoading = true;
      commonService.getSectors().then((res) => {
        const sectorTemp = res.data.data.sector;
        this.sectors = sectorTemp.map((item) => ({
          value: item.id,
          text: item.name,
        }));
        this.sectorsLoading = false;
      }).catch((err) => {
        this.sectorsLoading = false;
      });
    },
    handleAccountCity(cityId) {
      this.registerForm.company_city_id = parseInt(cityId);
      this.registerForm.cityName = "";
    },
    handleAccountCountry(countryId) {
      this.registerForm.company_country_id = parseInt(countryId);
      if (parseInt(countryId) !== 218) {
        this.registerForm.company_city_id = null;
        this.registerForm.cityName = "";
      }
    },
    selectRegion(region) {
      this.registerForm.region = region;
      this.regionDropdown = false;
    },
    handleSectorSelect(sectorId) {
      this.registerForm.sectorId = sectorId;
    },
    async register() {
      this.loading = true;
      try {
        const payload = {
          company_name: this.registerForm.company_name,
          company_address: this.registerForm.company_address,
          company_city_id: this.registerForm.company_country_id === 218 ? this.registerForm.company_city_id : null,
          city_name: this.registerForm.company_country_id !== 218 ? this.registerForm.cityName : null,
          authorized_name: this.registerForm.authorized_name,
          authorized_email: this.registerForm.authorized_email,
          authorized_phone: this.registerForm.authorized_phone,
          surname: this.registerForm.surname,
          region: this.registerForm.region,
          company_country_id: this.registerForm.company_country_id,
          sectorId: this.registerForm.sectorId,
        };
        await commonService.registerFromPanel(payload);
        this.$snackbar.add({
          text: "Kayıt başarılı!",
          type: "success",
        });
        this.isLoginScreen = true;
      } catch (err) {
        handleErrorResponse(err, this.$snackbar);
      } finally {
        this.loading = false;
      }
    },
    openPrivacyModal() {
      this.showPrivacyModal = true;
    },
    closePrivacyModal() {
      this.showPrivacyModal = false;
    },
    openTermsModal() {
      this.showTermsModal = true;
    },
    closeTermsModal() {
      this.showTermsModal = false;
    },
    updateLanguage(lang) {
      this.$i18n.locale = lang;
      localStorage.setItem('userLanguage', lang);
      window.location.reload();
    }
  },
}
</script>

<style scoped>
.login-main {
  background-color: #F9F6F2;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

header {
  position: fixed;
  display: flex;
  width: 100%;
  height: 104px;
  align-items: center;
  margin: 0;

  .logo {
    margin-left: 2.5rem;
  }
}

.login-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 0;
  flex: 1;

  .left, .right {
    width: 50%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }

}

.main-text {
  font-family: euclid_semi_bold, 'sans-serif';
  font-size: 40px;
  margin-bottom: 1rem;
}

.main-image {
  margin-top: 1rem;
  max-height: 264px;
}

.store-buttons {
  display: flex;
  gap: 16px;
  margin-top: 3.5rem;
}

.store-button {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 20px;
  border-radius: 12px;
  text-decoration: none;
  transition: all 0.2s ease;
}

.store-button.app-store {
  background-color: #4f67ef;
  color: #ffffff;
}

.store-button.play-store {
  background-color: #040c2d;
  color: #ffffff;
}

.store-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

.store-icon {
  width: 28px;
  height: 28px;
}

.store-text {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.store-subtitle {
  font-size: 10px;
  font-family: euclid_regular, 'sans-serif';
  opacity: 0.9;
}

.store-title {
  font-size: 14px;
  font-family: euclid_semi_bold, 'sans-serif';
  line-height: 1.2;
}

.login-form {
  background-color: #FFFFFF;
  box-shadow: 0 192px 77px rgba(171, 171, 171, 0.01), 0 108px 65px rgba(171, 171, 171, 0.05), 0 48px 48px rgba(171, 171, 171, 0.09), 0 12px 26px rgba(171, 171, 171, 0.1);
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  padding: 80px 32px;
  width: 60%;
}

.circular-btn {
}

.welcome-back {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 1rem;
}

.login-form-title {
  font-family: euclid_semi_bold, 'sans-serif';
  font-size: 32px;
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.policy-text {
  color: #98a2b3;
  font-family: 'euclid_regular', sans-serif;
  font-size: 12px;
  text-align: center;
  margin-top: 0.5rem;
  padding-left: 2rem;
  padding-right: 2rem;
}

.policy-text span {
  margin-right: 4px;
}

.policy-text span:last-child {
  margin-right: 0;
}

.policy-text-two {
  color: blue;
  font-family: 'euclid_regular', sans-serif;
  font-size: 12px;
}

.forgot-password {
  width: 100%;
  padding: 1rem;
  margin-top: 2rem;
  color: #667085;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-family: 'euclid_regular', sans-serif;
}

.forgot-password a {
  color: #4A68F8;
  text-decoration: none;
  font-family: 'euclid_medium', sans-serif;

}

.forgot-password a:hover {
  text-decoration: underline;
}

.forgot-password a:active {
  color: #4A68F8;
  text-decoration: none;
}

.language-selector {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}

.create-account {
  width: 100%;
  color: #667085;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 5px;
  font-size: 12px;
  font-family: 'euclid_regular', sans-serif;
}

.create-account span {
  color: #4A68F8;
  text-decoration: none;
  font-family: 'euclid_medium', sans-serif;

}

.create-account span:hover {
  text-decoration: underline;
  cursor: pointer;
}

.create-account span:active {
  color: #4A68F8;
  text-decoration: none;
}

@media (max-width: 1200px) {
  .login-form {
    width: 70%;
  }

  .main-text {
    font-size: 36px;
  }
}

@media (max-width: 996px) {
  .login-form {
    width: 80%;
  }

  .main-text {
    font-size: 32px;
  }
}

@media (max-width: 876px) {
  .login-container {
    .left {
      display: none;
    }

    .right {
      width: 100%;
    }
  }

  header {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .logo {
      margin-left: 0;

    }
  }

  .login-form {
    padding: 30px 20px;
  }
}

@media (max-width: 576px) {
  .login-form {
    width: 90%;
  }

  .login-form-title {
    font-size: 26px;
  }

  .login-image {
    width: 100px;
    margin-bottom: 10px;
  }

  .circular-btn {
    font-size: 15px;
    height: 40px;
  }

  .policy-text {
    font-size: 10px;
  }

  .forgot-password {
    margin-top: 1rem;
    font-size: 12px;
  }
}

@media (max-width: 376px) {
  .policy-text {
    font-size: 9px;
  }

  .forgot-password {
    font-size: 9px;
  }
}

.register-form {
  background: #fff;
  box-shadow: 0 8px 32px rgba(80, 80, 80, 0.08);
  border-radius: 16px;
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: start;
  width: 70%;
  max-width: 800px;
  position: relative;
}

.register-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 1.3rem;
  width: 100%;
}

.register-title {
  font-family: euclid_semi_bold, 'sans-serif';
  font-size: 1.2rem;
}

.register-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px 18px;
  width: 100%;
  margin-bottom: 1rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}


.back-button {
  background-color: #f5f5f5;
  padding: 8px;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: background-color 0.2s;
  cursor: pointer;
}

.back-button img {
  width: 20px;
  height: 20px;
}

.back-button:hover {
  background-color: #E5E5E5;
}
.policy-text span {
  margin-right: 4px;
}

.policy-text span:last-child {
  margin-right: 0;
}

.policy-text-two {
  color: blue;
  font-family: 'euclid_regular', sans-serif;
  font-size: 12px;
  cursor: pointer;
}
</style>
